// import library
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { NavLink } from "react-router-dom";
import moment from "moment/moment";
import Swal from "sweetalert2";
// import components
import Layout from "../../layouts/Layout";
import BarChart from "../../components/Dashboard/BarChart";
import MonthlyBarChart from "../../components/Dashboard/MonthlyBarChart";
import Pagination from "../../components/Dashboard/Pagination";
import NewsPagination from "../../components/Dashboard/NewsPagination";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import CommentForm from "../../components/Dashboard/CommentForm";
import ReplyForm from "../../components/Dashboard/ReplyForm";
import EditForm from "../../components/Dashboard/EditForm";
import LoaderIcon from "../../components/Common/Icon/Loader";

// import files
import { env } from "../../env";
import { AuthContext } from "../../context";
import { logEvent } from "../../analytics";

const Dashboard = () => {
    // variables
    const { t } = useTranslation();
    const authContext = useContext(AuthContext);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const [isLoader, setIsLoader] = useState(true);
    const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        notation: "compact",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        currency: 'EUR',
        currencyDisplay: 'narrowSymbol'
    });
    // const formatter1 = new Intl.NumberFormat('fr-FR', {
    //     style: 'decimal',
    //     notation: "compact",
    //     minimumFractionDigits: 2,
    //     maximumFractionDigits: 2,
    //     currency: 'EUR',
    //     currencyDisplay: 'narrowSymbol'
    // });
    const formatter1 = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const [categoryChartTab, setCategoryChartTab] = useState(currentYear);
    const [productChartTab, setProductChartTab] = useState(currentYear);
    const [rowCategoryCurrentPage, setCategoryCurrentPage] = useState(1);
    const [rowsCategoryPerPage, setCategoryRowsPerPage] = useState(15);
    const [categoryTotalRecords, setCategoryTotalRecords] = useState(0);
    const [rowProductCurrentPage, setProductCurrentPage] = useState(1);
    const [rowsProductPerPage, setProductRowsPerPage] = useState(15);
    const [productTotalRecords, setProductTotalRecords] = useState(0);
    const [rowNewsCurrentPage, setNewsCurrentPage] = useState(1);
    const [rowsNewsPerPage, setNewsRowsPerPage] = useState(5);

    const [sortName, setSortName] = useState('desc');
    const [showSort, setShowSort] = useState(false);
    const [showNewsInDetail, setShowNewsInDetail] = useState(false);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [newsTabId, setNewsTabId] = useState(1);
    const [newsTabName, setNewsTabName] = useState("Offers");
    const [activeNewsId, setActiveNewsId] = useState(0);
    const [isActiveMark, setIsActiveMark] = useState(false);
    const [isShowActiveArrow, setIsShowActiveArrow] = useState(false);
    const [commentAction, setCommentAction] = useState(false);
    const [showBox, setShowBox] = useState("comment");
    const [isLiked, setIsLiked] = useState(false);
    const isAdmin = parseInt(localStorage.getItem('isAdmin'));
    const [commentDataId, setCommentDataId] = useState(0);
    const [commentParentId, setCommentParentId] = useState(0);
    const [commentContent, setCommentContent] = useState("");
    const [viewComment, setViewComment] = useState(false);
    const [viewCommentId, setViewCommentId] = useState(0);

    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [categories, setCategories] = useState([]);
    const [categoryArticle, setCategoryArticles] = useState({
        "total_records": 0,
        "articles": []
    });
    const [revenueData, setRevenueData] = useState({});
    const [openBalanceData, setOpenBalanceData] = useState({});
    const [categoryChartData, setCategoryCartData] = useState([]);
    const [productChartData, setProductCartData] = useState([]);
    const [monthlyChartData, setMonthlyChartData] = useState(null);
    const [isMonthlyLoader, setIsMonthlyLoader] = useState(true);

    useEffect(() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const requestData = {
            "p_year_revenue_by_category": currentYear,
            "p_year_revenue_by_product": currentYear,  
            "p_pgnum_revenue_by_category": rowCategoryCurrentPage,
            "p_pgnum_revenue_by_product": rowProductCurrentPage
        }
        const fetchData = async () => {
            getCategoriesApi(baseUrl, token);
            getDashboardDataApi(baseUrl, token, requestData, 'all');
            getDefaultProductImage(baseUrl, token);
        };
        fetchData();
    }, []);

    // functions
    const getCategoriesApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/Product/GetNewsArticlesCategories",{ headers })
        .then((response) => {
            if(response.data) {
                setCategories(response.data);
                if(response.data.length > 0) {
                    setIsTableLoader(true);
                    getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'first');
                }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCategoryArticleApi = async (url, token, categoryId, page, sort, type) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetNewsArticlesListBasedOnCategory?categoryId=${categoryId}&page_num=${page}&ordertype=${sort}`,{ headers })
        .then((response) => {
            const readBox = [];
            if(response.data.articles) {
                setCategoryArticles(response.data);
                response.data.articles.map((article, index) => {
                    readBox.push(article.IsRead);
                });

                if(readBox.includes(false)){
                    setIsActiveMark(true);
                    if(type === 'first') {
                        setIsShowActiveArrow(true);
                    } else {
                        setIsShowActiveArrow(false);
                    }
                } else {
                    setIsActiveMark(false);
                    if(type === 'first') {
                        setIsShowActiveArrow(false);
                    }
                }
            } else {
                setCategoryArticles({
                    "total_records": 0,
                    "articles": []
                })
                setIsActiveMark(false);
                if(type === 'first') {
                    setIsShowActiveArrow(false);
                }
            }
            setIsTableLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getDashboardDataApi = async (url, token, data, type) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+ "/api/OfflineSync/GetDashboardSummary", data, { headers })
        .then((response) => {
            if(response.data) {
                if(type === 'all') {
                    setRevenueData(response.data[0].revenue_details);
                    const customerCode = response.data[0].revenue_details?.[0]?.SalesInvoiceTotalsPerYear?.[0]?.CustomerCode;
                    getMonthlyInvoiceData(customerCode);
                    setCategoryCurrentPage(response.data[1].current_page);
                    setCategoryRowsPerPage(response.data[1].page_size);
                    setCategoryTotalRecords(response.data[1].total_records);
    
                    setProductCurrentPage(response.data[2].current_page);
                    setProductRowsPerPage(response.data[2].page_size);
                    setProductTotalRecords(response.data[2].total_records);
    
                    setOpenBalanceData(response.data[3]?.OpenBalance?.[0]?.balance ?? 0);

                    if(response.data[1].revenue_by_category) {
                        const label = [];
                        const data = [];
                        const color = ['#d8f42b', '#70fa45', '#c66752', '#90b0b2', '#6a0ab2', '#6adb9f', '#f68fb6', '#10a9fc', '#a3fd8d', '#ff2f4b', '#8e8f32', '#222129', '#d7300d', '#b8bcc7', '#0fabae'];
    
                        response.data[1].revenue_by_category.map((value, index) => {
                            label.push(value.category_name);
                            data.push(value.revenue);
                        });
                        const categoryData = [label , data, color];
                        setCategoryCartData(categoryData);
                    } else {
                        setCategoryCartData([]);
                    }
    
                    if(response.data[2].revenue_by_product) {
                        const label = [];
                        const data = [];
                        const color = ['#fe3169', '#c73cad', '#5f07ee', '#70a6b0', '#d8f42b', '#70fa45', '#c66752', '#90b0b2', '#6a0ab2', '#6adb9f', '#f68fb6', '#10a9fc', '#a3fd8d', '#ff2f4b', '#8e8f32'];
    
                        response.data[2].revenue_by_product.map((value, index) => {
                            label.push(value.product_name);
                            data.push(value.revenue);
                        });
                        const productData = [label , data, color];
                        setProductCartData(productData);
                    } else {
                        setProductCartData([]);
                    }
                } else if(type === 'category') {
                    if(response.data[1].revenue_by_category) {
                        const label = [];
                        const data = [];
                        const color = ['#d8f42b', '#70fa45', '#c66752', '#90b0b2', '#6a0ab2', '#6adb9f', '#f68fb6', '#10a9fc', '#a3fd8d', '#ff2f4b', '#8e8f32', '#222129', '#d7300d', '#b8bcc7', '#0fabae'];
    
                        response.data[1].revenue_by_category.map((value, index) => {
                            label.push(value.category_name);
                            data.push(value.revenue);
                        });
                        const categoryData = [label , data, color];
                        setCategoryCartData(categoryData);
                    } else {
                        setCategoryCartData([]);
                    }
                } else if(type === 'product') {
                    if(response.data[2].revenue_by_product) {
                        const label = [];
                        const data = [];
                        const color = ['#fe3169', '#c73cad', '#5f07ee', '#70a6b0', '#d8f42b', '#70fa45', '#c66752', '#90b0b2', '#6a0ab2', '#6adb9f', '#f68fb6', '#10a9fc', '#a3fd8d', '#ff2f4b', '#8e8f32'];
    
                        response.data[2].revenue_by_product.map((value, index) => {
                            label.push(value.product_name);
                            data.push(value.revenue);
                        });
                        const productData = [label , data, color];
                        setProductCartData(productData);
                    } else {
                        setProductCartData([]);
                    }
                }
                setIsLoader(false);
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getMonthlyInvoiceData = async (customerCode) => {
        const clientToken = localStorage.getItem('clientToken');
        if (!clientToken || !customerCode) {
            setIsMonthlyLoader(false);
            return;
        }

        await axios.post(`${env.REACT_APP_RPC_URL}/rpc/get_customer_invoice_monthly_totals`, {
            p_customer_number: customerCode
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${clientToken}`
            }
        }).then((response) => {
            if (response.data && response.data.length > 0) {
                const years = [...new Set(response.data.map(d => d.invoice_year))].sort().slice(-3);
                const datasets = years.map((year) => {
                    const values = Array(12).fill(null);
                    response.data.filter(d => d.invoice_year === year).forEach(d => {
                        values[d.invoice_month - 1] = d.total_amount_excluding_tax;
                    });
                    return { label: String(year), data: values };
                });
                setMonthlyChartData(datasets);
            }
            setIsMonthlyLoader(false);
        }).catch((error) => {
            if (error.response?.data?.code === "PGRST301") {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                localStorage.removeItem("clientToken");
                window.location.reload();
                return;
            }
            console.log(error);
            setIsMonthlyLoader(false);
        });
    };
    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const markAllRead = async (url, token, id) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+ "/api/Product/UpdateReadFlagForDashboardNews", {
            "article_id": id
        }, { headers }).then((response) => {
            if(response.data.success === true) {
                getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'second');
                if(id === 'all') {
                    setIsActiveMark(false);
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: `${ t("marked all as read")}!`,
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });

    };
    const addNewComment = async (url, token, data, status) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+ "/api/Product/InsertNewsArticleComments", data, { headers })
        .then((response) => {
            if(response.data.success === true) {
                getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'second');
                setShowBox('comment');
                setCommentDataId(0);
                if(status === 'update') {
                    Swal.fire({
                        title: `${ t("comment updated")}!`,
                        text: `${ t("your comment is updated")}!`,
                        icon: "success"
                    });
                }  else if(status === 'reply') {
                    Swal.fire({
                        title: `${ t("reply added")}!`,
                        text: `${ t("your reply is added")}!`,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: `${ t("comment added")}!`,
                        text: `${ t("your comment is added")}!`,
                        icon: "success"
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const likeArticle = async (url, token, data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        axios.post(url+ "/api/product/InsertNewsArticleLike", data, { headers })
        .then((response) => {
            getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'second');
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleNewsTab = (e, tab) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'tab_change', tab);
        setNewsTabId(tab.category_id);
        setNewsTabName(tab.name);
        setCategoryArticles({
            "total_records": 0,
            "articles": []
        });
        setIsTableLoader(true);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCategoryArticleApi(baseUrl, token, tab.category_id, rowNewsCurrentPage, sortName, 'second');
    };
    const handleAllRead = (e) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'marked_all_read', 'read-all');
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        markAllRead(baseUrl, token, 'all');
    };
    const handleNewsCurrentPage = (page) => {
        logEvent('dashboard_page', 'article', 'pagination', page);
        setNewsCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setIsTableLoader(true);
        getCategoryArticleApi(baseUrl, token, newsTabId, page, sortName, 'second');
    };
    const handleNewsInDetail = (e, id, read) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'single_article_read', id);
        if(activeNewsId === id) {
            setShowNewsInDetail(!showNewsInDetail);
        } else {
            setShowNewsInDetail(true);
        }
        setActiveNewsId(id);
        if(!read) {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');
            markAllRead(baseUrl, token, id);
        }
    };
    const handleCommentAction = (e, commentId) => {
        e.preventDefault();
        setShowBox('comment');
        if(commentDataId === commentId) {
            setCommentAction(!commentAction);
        } else {
            setCommentAction(true);
        }
        setCommentDataId(commentId);
    };
    const handleReply = (e, commentId) => {
        e.preventDefault();
        setShowBox('reply');
        setCommentDataId(commentId);
    };
    const handleEdit = (e, comment) => {
        e.preventDefault();
        setShowBox('edit');
        setCommentDataId(comment.ID);
        setCommentContent(comment.Comment);
        setCommentParentId(comment.ParentID);
        setCommentAction(false);
    };
    const handleReplyBoxCloseFromChild = (data) => {
        setShowBox(data);
        setCommentDataId(0);
    };
    const handleEditBoxCloseFromChild = (data) => {
        setShowBox(data);
    };
    const handleCommentRequestFromChild = (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        logEvent('dashboard_page', 'article', 'comment', data);

        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to add comment")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                addNewComment(baseUrl, token, data, 'new');
            }
        });
    };
    const handleReplyRequestFromChild = (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        logEvent('dashboard_page', 'article', 'reply', data);
        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to reply")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                addNewComment(baseUrl, token, data, 'reply');
            }
        });
    };
    const handleEditRequestFromChild = (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        logEvent('dashboard_page', 'article', 'edit_comment', data);

        Swal.fire({
            title: `${ t("are you sure")}?`,
            text: `${ t("you want to edit your comment")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                addNewComment(baseUrl, token, data, 'update');
            }
        });
    };
    const handleSort = (e, data) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'sort', data);
        setSortName(data);
        setShowSort(!showSort);
        setIsTableLoader(true);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCategoryArticleApi(baseUrl, token, newsTabId, rowNewsCurrentPage, data, 'second');
    };
    const handleCategoryChartTab = (e, year) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const requestData = {
            "p_year_revenue_by_category": year,
            "p_year_revenue_by_product": currentYear,  
            "p_pgnum_revenue_by_category": 1,
            "p_pgnum_revenue_by_product": rowProductCurrentPage
        }
        getDashboardDataApi(baseUrl, token, requestData, 'category');
        setCategoryChartTab(year);
    };
    const handleProductChartTab = (e, year) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const requestData = {
            "p_year_revenue_by_category": currentYear,
            "p_year_revenue_by_product": year,  
            "p_pgnum_revenue_by_category": rowCategoryCurrentPage,
            "p_pgnum_revenue_by_product": 1
        }

        getDashboardDataApi(baseUrl, token, requestData, 'product');
        setProductChartTab(year);
    };
    const handleCategoryCurrentPage = (page) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const requestData = {
            "p_year_revenue_by_category": currentYear,
            "p_year_revenue_by_product": currentYear,  
            "p_pgnum_revenue_by_category": page,
            "p_pgnum_revenue_by_product": rowProductCurrentPage
        }
        getDashboardDataApi(baseUrl, token, requestData, 'category');
        setCategoryCurrentPage(page);
    };
    const handleProductCurrentPage = (page) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const requestData = {
            "p_year_revenue_by_category": currentYear,
            "p_year_revenue_by_product": currentYear,  
            "p_pgnum_revenue_by_category": rowCategoryCurrentPage,
            "p_pgnum_revenue_by_product": page
        }
        getDashboardDataApi(baseUrl, token, requestData, 'product');
        setProductCurrentPage(page);
    };
    const handleCategoryPerPage = (row) => {
        setCategoryRowsPerPage(row);
    };
    const handleProductPerPage = (row) => {
        setProductRowsPerPage(row);
    };
    const handleNewsPerPage = (row) => {
        setNewsRowsPerPage(row);
    };
    const handleLikeButton = (e, article ,index) => {
        e.preventDefault();
        if(article.IsLiked) {
            var like = false
        } else {
            var like = true
        }
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        let requestData = {
            "NewsArticlesID" : article.article_id,
            "IsLiked" : like
        };
        likeArticle(baseUrl, token, requestData);
    };
    const handleViewReplies = (e, commentId) => {
        e.preventDefault();
        if(viewCommentId === commentId) {
            setViewComment(!viewComment);
            if(viewComment) {
                setViewCommentId(0); 
            } else {
                setViewCommentId(commentId); 
            }
        } else {
            setViewComment(true);
            setViewCommentId(commentId);
        }
    };

    return (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                {/* first box */}
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="lg:text-2xl font-semibold capitalize">{ t('overview')}</h1>
                        <p className="text-light-400 text-sm capitalize"> { t('dashboard') } / { t('overview')}</p>
                    </div>
                </div>
                {/* content */}
                {
                    isLoader
                    ?
                        <LoaderIcon />
                    :
                    <div className="space-y-2 sm:space-y-4">
                        {/* comment section - hidden temporarily */}
                        {/* BANNER PLACEHOLDER */}
                        {/* <div>
                            <div className="w-full h-[250px] rounded-xl overflow-hidden relative bg-gradient-to-r from-blue-600 via-blue-500 to-indigo-600 flex items-center justify-between px-8 sm:px-16 shadow-around">
                                <div className="text-white space-y-3 z-10">
                                    <div className="text-xs sm:text-sm font-medium uppercase tracking-widest opacity-80">Special Offer</div>
                                    <div className="text-2xl sm:text-4xl font-bold leading-tight">Your Banner<br/>Goes Here</div>
                                    <div className="text-xs sm:text-sm opacity-70">Replace this placeholder with your actual banner image</div>
                                    <div className="inline-block bg-white text-blue-600 font-semibold text-xs sm:text-sm px-4 py-2 rounded-lg cursor-pointer">Learn More</div>
                                </div>
                                <div className="absolute right-0 top-0 h-full w-1/3 flex items-center justify-end pr-8 opacity-20">
                                    <div className="w-48 h-48 rounded-full border-4 border-white absolute right-16 top-4"></div>
                                    <div className="w-64 h-64 rounded-full border-4 border-white absolute right-4 -top-8"></div>
                                    <div className="w-32 h-32 rounded-full bg-white absolute right-8 bottom-4"></div>
                                </div>
                                <div className="hidden sm:flex z-10 items-center justify-center w-32 h-32 bg-white bg-opacity-20 rounded-2xl">
                                    <svg className="w-16 h-16 text-white opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="mt-1 text-center text-xs text-gray-400">Recommended banner dimensions: <span className="font-semibold text-gray-500">1200 × 250 px</span></div>
                        </div> */}
                        {false && <div className={((categoryArticle.articles.length > 0 && isShowActiveArrow) ? "h-[4.5rem] overflow-hidden" : "") + " border border-white bg-white rounded-xl p-2 sm:p-4 space-y-3 shadow-around"}>
                            <div className="sm:flex sm:justify-between sm:items-center space-y-2 sm:space-y-0">
                                <div className="flex space-x-2 sm:space-x-4 items-center">
                                    {categories.length > 0 ?
                                        categories.map((tab, index) => (
                                            <div key={`tab${tab.category_id}`} onClick={(e) => handleNewsTab(e, tab)} className={( newsTabId === tab.category_id ? 'bg-blue-light text-blue-normal' : 'text-gray-dark') + " cursor-pointer text-xs sm:text-base py-2 px-2 sm:px-4 text-center rounded-lg capitalize font-semibold"}>{tab.name}</div>
                                        ))
                                    : null}
                                </div>
                                { categoryArticle.articles.length > 0 ? 
                                    <div className="text-xs sm:text-base flex justify-end sm:justify-between lg:justify-normal space-x-2 sm:space-x-4 items-center">
                                        <div onClick={(e) => isActiveMark ? handleAllRead(e) : null} className={(isActiveMark ? "cursor-pointer text-blue-normal" : "cursor-not-allowed text-gray-dark") + " text-center rounded-lg first-letter:capitalize font-semibold"}>{ t('mark all as read')}</div>
                                        <div className="cursor-pointer relative text-light-400 text-center rounded-lg capitalize font-semibold flex" onClick={(e) => setShowSort(!showSort)}>
                                            <div className="mr-2">{ sortName === 'desc' ? t('latest') : t('oldest')}</div>
                                            <img src="../../../assets/icons/table/sort-arrow-down.svg" alt="arrow" />  
                                            { showSort ? 
                                                <div className="absolute w-fit top-6 right-0 z-10 text-background-dark bg-white shadow-md rounded-md">
                                                    <ul>
                                                        <li key="latest" onClick={(e) => handleSort((e), 'desc')}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{ t('latest')}</li>
                                                        <li key="oldest" onClick={(e) => handleSort((e), 'asc')}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{ t('oldest')}</li>
                                                    </ul> 
                                                </div>
                                            : null }  
                                        </div>
                                        <div className="cursor-pointer" onClick={(e) => setIsShowActiveArrow(!isShowActiveArrow)}><img className="w-3 h-3 sm:w-4 sm:h-4" src="../../assets/icons/select-down.svg" alt="select-down" /></div>
                                    </div>
                                : null }
                            </div>
                            <div className="bg-news-normal rounded-md py-2 sm:p-4 space-y-3">
                                { isTableLoader
                                    ?
                                        <TableLoaderIcon />
                                    :
                                        categoryArticle.articles.length > 0 ?
                                            categoryArticle.articles.map((article, index) => (
                                                <div key={`article${article.article_id}`} className={(!article.IsRead ? "bg-yellow-light border-news-border1" : " bg-white border-news-border" )+ " bg-white border-news-border flex space-x-1 sm:space-x-3 border rounded-md p-2"}>
                                                    {/* left grid col */}
                                                    <div className="flex flex-col">
                                                        <img className={ ((showNewsInDetail && activeNewsId === article.article_id) ? " h-14 w-14 sm:h-56 sm:w-56" : "h-14 w-14 sm:h-16 sm:w-16") + " rounded max-w-fit sm:max-w-none"} src={article.Image1 ? article.Image1 : defaultProductImage} alt="image" />
                                                    </div>
                                                    {/* right grid col */}
                                                    <div className="flex flex-col w-full justify-evenly pr-1 py-2 space-y-3">
                                                        {/* heading */}
                                                        <div className="flex justify-between w-full">
                                                            <h1 className="font-bold text-xs sm:text-sm">{article.title}</h1>
                                                            <img onClick={(e) => handleNewsInDetail(e, article.article_id, article.IsRead)} className="cursor-pointer w-3 h-3" src={`../../../assets/icons/table/sort-arrow-${(showNewsInDetail && activeNewsId === article.article_id) ? 'up' : 'down'}.svg`} alt="arrow" /> 
                                                        </div>
                                                        {/* content */}
                                                        <div className="flex items-center">
                                                            <div className={((showNewsInDetail && activeNewsId === article.article_id)? 'w-[90%]' : 'line-clamp-1') + " text-xs sm:text-sm"} dangerouslySetInnerHTML={{ __html: article.content }}></div>
                                                            { (showNewsInDetail && activeNewsId === article.article_id && newsTabName === 'Offers') ? 
                                                                (!isAdmin) ? 
                                                                    <div className="flex flex-col justify-between items-center w-[10%] ml-4">
                                                                        <div onClick={(e) => handleLikeButton(e, article, index)} className="bg-background-normal rounded-full p-1 flex justify-center cursor-pointer">
                                                                            <img className="p-2" src={`../../../assets/icons/dashboard/heart-${article.IsLiked ? 'red' : 'white'}.svg`} alt="heart" />
                                                                        </div>
                                                                    </div>
                                                                : null
                                                                // <div className="flex flex-col justify-between items-center w-16 ml-4">
                                                                //     <div className="bg-background-normal rounded-full p-1 flex justify-center cursor-pointer">
                                                                //         <img className="p-2" src={`../../../assets/icons/dashboard/heart-red.svg`} alt="heart" />
                                                                //     </div>
                                                                //     <div className="text-xs">200 Likes</div>
                                                                // </div>
                                                            : null}
                                                        </div>
                                                        {/* published */}
                                                        {(showNewsInDetail && activeNewsId === article.article_id) ?
                                                            newsTabName !== 'Offers' ?
                                                                <div className="sm:flex space-x-1 sm:space-x-0 sm:justify-between sm:items-center">
                                                                    <div className="sm:flex space-x-1 sm:space-x-2 text-xs italic"><span className="first-letter:capitalize text-light-400">{ t('published by')}</span> <span className="font-bold">{article.username} </span><span className="text-light-400">{ t('on')}</span><span className="font-bold">{ moment(article.publication_date).format('Do MMMM YYYY')}</span></div>
                                                                    {(!isAdmin) ? 
                                                                        <div className="flex flex-col justify-center items-center">
                                                                            <div onClick={(e) => handleLikeButton(e, article)} className="bg-background-normal rounded-full p-2.5 flex justify-center cursor-pointer">
                                                                                <img src={`../../../assets/icons/dashboard/heart-${article.IsLiked ? 'red' : 'white'}.svg`} alt="heart" />
                                                                            </div>
                                                                        </div>
                                                                    : null
                                                                        // <div className="flex flex-col justify-between items-center w-16 ml-4">
                                                                        //     <div className="bg-background-normal rounded-full p-1 flex justify-center cursor-pointer">
                                                                        //         <img className="p-2" src={`../../../assets/icons/dashboard/heart-red.svg`} alt="heart" />
                                                                        //     </div>
                                                                        //     <div className="text-xs">200 Likes</div>
                                                                        // </div>
                                                                    }
                                                                </div>
                                                            : null
                                                        : null}
                                                        {/* horizontal line */}
                                                        {(showNewsInDetail && activeNewsId === article.article_id) ? <div className="border-t border-background-normal"></div> : null }
                                                        {/* comments */}
                                                        {(showNewsInDetail && activeNewsId === article.article_id) ?
                                                            ((!isAdmin) ? 
                                                                <div className="space-y-3">
                                                                    {article.comments ? 
                                                                        <div className={((article.comments.length > 3) ? "h-40 overflow-y-scroll": "") + " space-y-3"}>
                                                                            { article.comments.map((comment, index1) => (
                                                                                (comment.Comment.length > 0) ? 
                                                                                    <div key={`comment${comment.ID}`} className="flex items-start w-full">
                                                                                        <div className="p-1 sm:p-3 rounded-full bg-sky-light w-max">
                                                                                            <img className="w-2 h-2 sm:w-3 sm:h-3" src="../../../assets/icons/dashboard/profile.svg" alt="profile"/>
                                                                                        </div>
                                                                                        <div className="ml-1 sm:ml-2 w-full">
                                                                                            <div className="sm:flex space-x-1 sm:space-x-2 text-[10px] sm:text-xs">
                                                                                                <span className="font-bold capitalize">{ t('you')}</span> <span className="text-light-400">{ t('commented on')}</span><span className="font-bold">{ moment(comment.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                                {/* action */}
                                                                                                <div className="ml-3 relative">
                                                                                                    <div className="p-1 cursor-pointer">
                                                                                                        <img onClick={(e) => handleCommentAction(e, comment.ID)} src="../../../assets/icons/dashboard/dots-vertical.svg" alt="dot" />
                                                                                                    </div>
                                                                                                    {(commentAction && commentDataId === comment.ID) ?
                                                                                                        <div className="absolute w-max left-8 z-40 -top-2 bg-white border border-white shadow-md rounded-md">
                                                                                                            <ul>
                                                                                                                <li onClick={(e) => handleEdit(e, comment)} className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                    <img className="mr-2" src="../../../assets/icons/dashboard/edit.svg" alt="edit" />{ t('edit') }
                                                                                                                </li>
                                                                                                                <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                    <img className="mr-2" src="../../../assets/icons/dashboard/delete.svg" alt="delete" />{ t('delete') }
                                                                                                                </li>
                                                                                                            </ul>
                                                                                                        </div>
                                                                                                    : null }
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="text-[10px] sm:text-xs">
                                                                                                {comment.Comment}
                                                                                            </div>
                                                                                            {comment.Replies ? 
                                                                                                (viewComment && viewCommentId === comment.ID) ?
                                                                                                    comment.Replies.map((reply, index2) => (
                                                                                                        <div key={`comment${reply.ID}`} className="flex items-start rounded-xl bg-news-normal p-2.5 w-full mt-3">
                                                                                                            <div className="p-3 rounded-full bg-gray-dark2">
                                                                                                                <img className="w-3 h-3" src="../../../assets/icons/dashboard/admin.svg" alt="admin"/>
                                                                                                            </div>
                                                                                                            <div className="ml-2 space-y-1">
                                                                                                                <div className="flex space-x-2 text-[10px] sm:text-xs">
                                                                                                                    <span className="font-bold capitalize">{(authContext.userInfo.userName === reply.UserName) ? t('you') : reply.Name}</span> <span className="capitalize text-light-400">{ t('replied')}</span><span className="font-bold">{ moment(reply.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                                                </div>
                                                                                                                <div className="text-[10px] sm:text-xs">
                                                                                                                    {reply.Comment}
                                                                                                                </div>
                                                                                                                {(showBox !== 'reply' || commentDataId !== comment.ID) ? <div onClick={(e) => handleReply(e, comment.ID)} className="capitalize text-light-400 font-semibold text-[10px] cursor-pointer">{ t('reply')}</div> : null}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ))
                                                                                                : null
                                                                                                : null
                                                                                            }
                                                                                            {comment.Replies ? 
                                                                                                <div className="text-[10px] sm:text-xs cursor-pointer font-medium text-light-400" onClick={(e) => handleViewReplies(e, comment.ID)}>
                                                                                                    {(viewCommentId !== comment.ID) ? 'view replies' : 'hide replies'}
                                                                                                </div>
                                                                                                : null
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                : null
                                                                            ))}
                                                                        </div>
                                                                    : null}
                                                                    {(showBox === 'comment') ? <div><CommentForm article={article.article_id} sendCommentRequestFromChild={handleCommentRequestFromChild}/></div> : null}
                                                                    {(showBox === 'reply') ? <div><ReplyForm article={article.article_id} commentId={commentDataId} comment={commentContent} sendReplyRequestFromChild={handleReplyRequestFromChild} sendReplyBoxCloseFromChild={handleReplyBoxCloseFromChild} /></div> : null}
                                                                    {(showBox === 'edit') ? <div><EditForm article={article.article_id} commentId={commentDataId} parentId={commentParentId} comment={commentContent} sendEditRequestFromChild={handleEditRequestFromChild} sendEditBoxCloseFromChild={handleEditBoxCloseFromChild} /></div> : null}
                                                                </div>
                                                            :
                                                                <div className="space-y-3">
                                                                    {article.comments ? 
                                                                        ((article.comments.length > 1) ?
                                                                            <div className={((article.comments.length > 3) ? "h-40 overflow-y-scroll": "") + " space-y-3"}>
                                                                                { article.comments.map((comment, index1) => (
                                                                                    (comment.Comment.length > 0) ? 
                                                                                        <div key={`comment${comment.ID}`} className="flex items-start w-full">
                                                                                            <div className="p-1 sm:p-3 rounded-full bg-sky-light w-max">
                                                                                                <img className="w-2 h-2 sm:w-3 sm:h-3" src="../../../assets/icons/dashboard/profile.svg" alt="profile"/>
                                                                                            </div>
                                                                                            <div className="ml-1 sm:ml-2 w-full">
                                                                                                <div className="sm:flex space-x-1 sm:space-x-2 text-[10px] sm:text-xs">
                                                                                                    <span className="font-bold capitalize">{ comment.Name }</span>
                                                                                                    <span className="text-light-400">{ t('commented on')}</span>
                                                                                                    <span className="font-bold">{ moment(comment.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                                </div>
                                                                                                <div className="text-[10px] sm:text-xs">
                                                                                                    {comment.Comment}
                                                                                                </div>
                                                                                                {(commentDataId !== comment.ID) ? 
                                                                                                    <div onClick={(e) => handleReply(e, comment.ID)} className="capitalize text-light-400 font-semibold text-[10px] cursor-pointer">{ t('reply')}</div> 
                                                                                                    : 
                                                                                                    <div className="mt-3"><ReplyForm article={article.article_id} commentId={commentDataId} comment={commentContent} sendReplyRequestFromChild={handleReplyRequestFromChild} sendReplyBoxCloseFromChild={handleReplyBoxCloseFromChild} /></div> 
                                                                                                }
                                                                                                {comment.Replies ? 
                                                                                                    (viewComment && viewCommentId === comment.ID) ?
                                                                                                        comment.Replies.map((reply, index2) => (
                                                                                                            <div key={`comment${reply.ID}`} className="flex items-start rounded-xl bg-news-normal p-2.5 w-full mt-3">
                                                                                                                <div className="p-3 rounded-full bg-gray-dark2">
                                                                                                                    <img className="w-3 h-3" src="../../../assets/icons/dashboard/admin.svg" alt="admin"/>
                                                                                                                </div>
                                                                                                                <div className="ml-2 space-y-1">
                                                                                                                    <div className="sm:flex space-x-1 sm:space-x-2 text-[10px] sm:text-xs">
                                                                                                                        <span className="font-bold">{(authContext.userInfo.userName === reply.UserName) ? t('you') : reply.Name}</span> <span className="capitalize text-light-400">{ t('replied')}</span><span className="font-bold">{ moment(reply.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                                                        <div className="ml-3 relative">
                                                                                                                            <div className="p-1 cursor-pointer">
                                                                                                                                <img onClick={(e) => handleCommentAction(e, reply.ID)} src="../../../assets/icons/dashboard/dots-vertical.svg" alt="dot" />
                                                                                                                            </div>
                                                                                                                            {(commentAction && commentDataId === reply.ID) ?
                                                                                                                                    <div className="absolute w-max left-8 z-40 -top-14 bg-white border border-white shadow-md rounded-md">
                                                                                                                                        <ul>
                                                                                                                                            <li onClick={(e) => handleEdit(e, reply)} className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                                                <img className="mr-2" src="../../../assets/icons/dashboard/edit.svg" alt="edit" />{ t('edit') }
                                                                                                                                            </li>
                                                                                                                                            <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                                                <img className="mr-2" src="../../../assets/icons/dashboard/delete.svg" alt="delete" />{ t('delete') }
                                                                                                                                            </li>
                                                                                                                                        </ul>
                                                                                                                                    </div>
                                                                                                                            : null }
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <div className="text-xs">
                                                                                                                        {(showBox === 'edit' && commentDataId === reply.ID) ? <div><EditForm article={article.article_id} commentId={commentDataId} parentId={commentParentId} comment={commentContent} sendEditRequestFromChild={handleEditRequestFromChild} sendEditBoxCloseFromChild={handleEditBoxCloseFromChild} /></div> : reply.Comment}
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        ))
                                                                                                        : null
                                                                                                    : 
                                                                                                    null
                                                                                                }
                                                                                                {comment.Replies ? 
                                                                                                    <div className="text-xs cursor-pointer font-medium text-light-400" onClick={(e) => handleViewReplies(e, comment.ID)}>
                                                                                                        {(viewCommentId !== comment.ID) ? 'view replies' : 'hide replies'}
                                                                                                    </div>
                                                                                                    : null
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    : null
                                                                                ))}
                                                                            </div>
                                                                        : 
                                                                            <div className="text-center font-bold text-xs sm:text-lg capitalize">
                                                                                { t('no comments yet')}
                                                                            </div>)
                                                                    : 
                                                                        <div className="text-center font-bold text-xs sm:text-lg capitalize">
                                                                            { t('no comments yet')}
                                                                        </div>
                                                                    }
                                                                </div>)
                                                        : null}
                                                    </div>
                                                </div>
                                            ))
                                        :
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t(newsTabName.toLowerCase() + ' not available')}
                                        </div>
                                }
                            </div>
                            <div>
                               <NewsPagination 
                                    currentPage={rowNewsCurrentPage}
                                    totalCount={categoryArticle.total_records}
                                    pageSize={rowsNewsPerPage}
                                    onPageChange={page => handleNewsCurrentPage(page)}
                                    onPageSizeChange={row => handleNewsPerPage(row)}
                                />
                            </div>
                        </div>}
                        {/* total boxes */}
                        <div className="xl:grid xl:grid-cols-2 xl:gap-4 space-y-2 sm:space-y-4 xl:space-y-0">
                            <div className="bg-blue-normal bg-box-blue rounded-[10px] text-white px-3 py-5 sm:px-5 flex flex-col justify-center min-h-28">
                                {(() => {
                                    const salesData = [...(revenueData[0].SalesInvoiceTotalsPerYear || [])]
                                        .sort((a, b) => b.InvoiceYear - a.InvoiceYear)
                                        .slice(0, 3);
                                    const colCount = salesData.length > 0 ? salesData.length + 1 : 2;
                                    return (
                                        <div className={`grid grid-cols-${colCount} divide-x-1 divide-[#e6e6e666] divide-dashed`}>
                                            <div className="space-y-1">
                                                <img src="../../../assets/icons/bus.svg" alt="bus" />
                                                <h1 className="capitalize text-xs sm:text-base font-semibold">{ t('total orders')}</h1>
                                            </div>
                                            {salesData.length > 0 ? salesData.map((entry) => (
                                                <div key={entry.InvoiceYear} className="space-y-1 text-center">
                                                    <h1 className="font-semibold text-xs sm:text-lg">{formatter1.format(entry.TotalAmountExcludingTax)} €</h1>
                                                    <div className="text-sm">in {entry.InvoiceYear}</div>
                                                </div>
                                            )) : (
                                                <div className="space-y-1 text-center flex items-center justify-center">
                                                    <h1 className="font-semibold text-xs sm:text-lg">--</h1>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                            {/* total revenue box - hidden temporarily */}
                            {false && <div className="bg-yellow-normal bg-box-yellow rounded-[10px] flex flex-col justify-center text-white px-3 py-5 sm:px-5 min-h-28">
                                <div className="grid grid-cols-4 divide-x-1 divide-[#e6e6e666] divide-dashed">
                                    <div className="space-y-1">
                                        <img src="../../../assets/icons/coin-bag.svg" alt="bus" />
                                        <h1 className="capitalize text-xs sm:text-base font-semibold">{ t('total revenue')}</h1>
                                    </div>
                                    <div className="space-y-1 text-center">
                                        <div>
                                            <h1 className="font-semibold text-xs sm:text-2xl">{revenueData[0].TotalRevenue ? formatter.format(revenueData[0].TotalRevenue) : formatter.format(0)}</h1>
                                        </div>
                                        <div className="text-xs sm:text-sm">in {currentYear}</div>
                                        <div className="text-xs">({revenueData[0].RevenueChangePercentage ? revenueData[0].RevenueChangePercentage : 0}% YoY)</div>
                                    </div>
                                    <div className="space-y-1 text-center">
                                        <h1 className="font-semibold text-xs sm:text-2xl">{revenueData[0].LastYearRevenue ? formatter.format(revenueData[0].LastYearRevenue) : formatter.format(0)}</h1>
                                        <div className="text-xs sm:text-sm">in {currentYear-1}</div>
                                    </div>
                                    <div className="space-y-1 text-center">
                                        <h1 className="font-semibold text-xs sm:text-2xl">{openBalanceData ? formatter.format(openBalanceData) : formatter.format(0)}</h1>
                                        <div className="text-xs sm:text-sm capitalize">{ t('open balance')}</div>
                                    </div>
                                </div>
                            </div>}
                            {/* credit limit / balance / payment type box */}
                            <div className="bg-yellow-normal bg-box-yellow rounded-[10px] flex flex-col justify-center text-white px-3 py-5 sm:px-5 min-h-28">
                                <div className="grid grid-cols-5 divide-x-1 divide-[#e6e6e666] divide-dashed">
                                    <div className="flex flex-col justify-between space-y-1">
                                        <img src="../../../assets/icons/coin-bag.svg" alt="coin-bag" className="w-10 h-10" />
                                        <h1 className="capitalize text-xs sm:text-base font-semibold">{ t('account info')}</h1>
                                    </div>
                                    <div className="flex flex-col justify-between text-center px-1">
                                        <h1 className="font-semibold text-xs sm:text-lg">{revenueData[0].CreditLimit ? formatter1.format(revenueData[0].CreditLimit) + ' €' : '--'}</h1>
                                        <div className="text-xs sm:text-sm capitalize mt-1">{ t('credit limit')}</div>
                                    </div>
                                    <div className="flex flex-col justify-between text-center px-1">
                                        <h1 className="font-semibold text-xs sm:text-lg">{revenueData[0].BalanceDue ? formatter1.format(revenueData[0].BalanceDue) + ' €' : '--'}</h1>
                                        <div className="text-xs sm:text-sm capitalize mt-1">{ t('balance due')}</div>
                                    </div>
                                    <div className="flex flex-col justify-between text-center px-1">
                                        <h1 className="font-semibold text-xs sm:text-lg">{revenueData[0].OpenBalance ? formatter1.format(revenueData[0].OpenBalance) + ' €' : '--'}</h1>
                                        <div className="text-xs sm:text-sm capitalize mt-1">{ t('open balance')}</div>
                                    </div>
                                    <div className="flex flex-col justify-between text-center px-1">
                                        <h1 className="font-semibold text-xs sm:text-sm">{revenueData[0].DisplayName?.[0] ? revenueData[0].DisplayName[0] : '--'}</h1>
                                        <div className="text-xs sm:text-sm capitalize mt-1">{ t('payment type')}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* charts */}
                        {/* <div className="xl:grid xl:grid-cols-2 xl:gap-4 space-y-2 sm:space-y-4 xl:space-y-0">
                            <div className="bg-white rounded-[10px] p-2 sm:p-5 shadow-around"> 
                                <div className="flex justify-between items-center">
                                    <h1 className="font-bold text-[10px] sm:text-lg lg:text-2xl capitalize">{ t('categories vs. revenue')}</h1>
                                    <div className="flex space-x-2 sm:space-x-6">
                                        <button onClick={(e) => handleCategoryChartTab(e, currentYear)} className={( categoryChartTab === currentYear ? 'bg-blue-light text-blue-normal py-2 px-4 ' : 'text-gray-dark') + " text-center text-xs sm:text-base rounded-lg capitalize"} >{currentYear}</button>
                                        <button onClick={(e) => handleCategoryChartTab(e, currentYear-1)} className={( categoryChartTab === (currentYear-1) ? 'bg-blue-light text-blue-normal py-2 px-4 ' : 'text-gray-dark') + " text-center text-xs sm:text-base rounded-lg capitalize"} >{ currentYear-1 }</button>
                                    </div>
                                </div>
                                <div>
                                    {categoryChartData.length > 0 ? 
                                        <BarChart chartData={categoryChartData}/>
                                        : 
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t('no records available')}
                                        </div>
                                    }
                                </div>
                                {
                                    categoryChartData.length > 0 ?
                                        <Pagination
                                            currentPage={rowCategoryCurrentPage}
                                            totalCount={categoryTotalRecords}
                                            pageSize={rowsCategoryPerPage}
                                            onPageChange={page => handleCategoryCurrentPage(page)}
                                            onPageSizeChange={row => handleCategoryPerPage(row)}
                                        />
                                    : null
                                }
                            </div>
                            <div className="bg-white rounded-[10px] p-2 sm:p-5 shadow-around"> 
                                <div className="flex justify-between items-center">
                                    <h1 className="font-bold text-[10px] sm:text-lg lg:text-2xl capitalize">{ t('products vs. revenue')}</h1>
                                    <div className="flex space-x-2 sm:space-x-6">
                                        <button onClick={(e) => handleProductChartTab(e, currentYear)} className={( productChartTab === currentYear ? 'bg-blue-light text-blue-normal py-2 px-4 ' : 'text-gray-dark') + " text-center text-xs sm:text-base rounded-lg capitalize"} >{currentYear}</button>
                                        <button onClick={(e) => handleProductChartTab(e, currentYear-1)} className={( productChartTab === (currentYear-1) ? 'bg-blue-light text-blue-normal py-2 px-4 ' : 'text-gray-dark') + " text-center text-xs sm:text-base rounded-lg capitalize"} >{ currentYear-1 }</button>
                                    </div>
                                </div>
                                <div>
                                    {productChartData.length > 0 ? 
                                        <BarChart chartData={productChartData}/>
                                        : 
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t('no records available')}
                                        </div>
                                    }
                                </div>
                                {
                                    productChartData.length > 0 ?
                                        <Pagination
                                            currentPage={rowProductCurrentPage}
                                            totalCount={productTotalRecords}
                                            pageSize={rowsProductPerPage}
                                            onPageChange={page => handleProductCurrentPage(page)}
                                            onPageSizeChange={row => handleProductPerPage(row)}
                                        />
                                    : null
                                }
                            </div>
                        </div> */}
                        {/* monthly revenue chart */}
                        <div className="bg-white rounded-[10px] p-2 sm:p-5 shadow-around">
                            <div className="flex justify-between items-center">
                                <h1 className="font-bold text-[10px] sm:text-lg lg:text-2xl capitalize">{ t('monthly revenue')}</h1>
                            </div>
                            <div>
                                {isMonthlyLoader
                                    ? <TableLoaderIcon />
                                    : monthlyChartData
                                        ? <MonthlyBarChart datasets={monthlyChartData} />
                                        : <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">{ t('no records available')}</div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Layout>
    )
}

export default Dashboard;